<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Novo Motivo de Ausência <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form" @submit.prevent>
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="name"><span class="required">*</span> Nome do Motivo de Ausência</label>
                        <input type="text" class="form-control" name="name" v-model="absenceReason.name" id="name">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/absence-reasons" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                absenceReason: {
                    name: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'absence-reasons';

                let form  = new FormData();
                let photo = document.getElementById('photo');

                form.append('name', self.absenceReason.name);

                self.$http.post(api, form)
                    .then((response) => {
                        self.absenceReasons = response.data.data;
                        self.tableData = self.absenceReasons;

                        self.$message('Sucesso', `Motivo de Ausência cadastrado com sucesso`, 'success');

                        this.$router.push('/absence-reasons');

                        self.absenceReason = {
                            name: '',
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/AbsenceReason/Add.vue